module.exports = __webpack_public_path__ + "static/media/aave.aadf289d.svg";